enum FileTypeEnum {
  FILE = 'FILE',
  FOLDER = 'FOLDER',
}

export default FileTypeEnum;
